/* To-do list
Important Tasks
1. Make footer.
2. Add whatsapp contact.
3. Add special mouse.
4. Add logo to responsive/mobile header.
5. Add icon to the title.
6. Finish styling cart drawer.
7. Add checkout page.
8. Add search page.
9. Add tags.
10. Add the related products below to the product page.


Bug Report
Fix y axis scrolling on drawer dropdown, when selected dropdown.

*/

import {Routes, Route, Outlet} from 'react-router-dom';
import './index.css';
import cover1 from './Designs/1.jpg';
import cover2 from './Designs/2.jpeg';
import Header from './Containers/Header/Header';
import PageCover from './Containers/PageCover/PageCover';
import URLS from './URLS';
import Home from './Pages/Home/Home';
import {useEffect} from 'react';
import ProductPage from './Pages/ProductPagesData/ProductPage/ProductPage';
import {connect} from 'react-redux';
import globalactions from './Redux/actions/global';
import Checkout from './Pages/Checkout/Checkout';

const HomePageCover = () => {
  return <PageCover interval={5000}
                    images={[cover1, cover2]}
                    fadeText={"Pasteleria Valentina"} />
}

const mapDispatchToProps = dispatch => ({
  setDatabase: () => dispatch(globalactions.setProductDatabase())
});

const mapStateToProps = state => ({
  productRoutes: JSON.parse(localStorage.getItem("products")) || state.changeProducts
});

const App = ({productRoutes, setDatabase}) => {

  useEffect(() => {
    setDatabase();
  }, [])

  return (
    <>
      <Routes>
        <Route element={<Header/>} path={"*"}>
          {
            productRoutes.map(({title, price, link, category, subcategory, description}, index) => {
              return <Route
                element={<>
                  <span className={"no-cover"}/>
                  <ProductPage title={title}
                    price={price}
                    category={category}
                    description={description}
                    subcategory={subcategory}/>
                </>} key={index} path={link}/>
            })
          }
          <Route element={<>
              <HomePageCover/>
              <Home products={productRoutes}/>
            </>} path={URLS.HOME}/>
          <Route element={
              <>
                <span className={"no-cover"}/>
                <Checkout/>
              </>
            } path={URLS.CHECKOUT}/>
          <Route element={<>
              <HomePageCover/>
              <Home products={productRoutes}/>
            </>} path={"*"}/>
        </Route>
      </Routes>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
